import React, { Component } from 'react';
import PrivateRoute from './components/auth/PrivateRoute';
import ItemsContainer from './components/ItemsContainer';
import './App.css';
import LoginContainer from './components/LoginContainer'
import { Switch, Route, Redirect } from 'react-router-dom';
import Health from './components/Health';
import NavBar from './components/NavBar'
import authHelpers from './components/auth/AuthHelpers'

class App extends Component {


  handleLogout = () => {
    authHelpers.logout();
  }

  render() {
    return (

      <div>

        <NavBar title="TRENCH Admin-Cockpit" 
                showLogout={authHelpers.isAuthenticated()}
                handleLogout={this.handleLogout} />

        <Switch>
          <Route exact path='/login' component={LoginContainer} />
          <Route exact path='/health' component={Health} />
          <PrivateRoute path='/home' component={ItemsContainer} />
          <Route exact path="/" render={() => (
            <Redirect to="/home" />
          )} />
        </Switch>
        
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js